import _ from 'lodash';
import moment from 'moment';

class ComplementoCartaPorteRequestInputTransformer {
  getName() {
    return 'CartaPorte';
  }

  make(input) {
    const { Complemento = {} } = input;

    if (!Complemento || !Complemento.CartaPorte) {
      return input;
    }

    let cartaPorte = { ...Complemento.CartaPorte };

    cartaPorte = this._clearInput(cartaPorte);

    let { RegimenesAduaneros = {}, Ubicaciones = {}, Mercancias = {}, FiguraTransporte = {} } = cartaPorte;
    let { RegimenAduaneroCCP = [] } = RegimenesAduaneros;
    let { Ubicacion = [] } = Ubicaciones;
    let { Mercancia = [], Autotransporte = {} } = Mercancias;
    let { TiposFigura = [] } = FiguraTransporte;

    RegimenAduaneroCCP = RegimenAduaneroCCP.map((item) => {
      return this._clearInput(item);
    });

    Ubicacion = Ubicacion.map((item) => {
      item = this._clearInput(item);

      item.FechaHoraSalidaLlegada = moment(item.FechaHoraSalidaLlegada).format('YYYY-MM-DDTHH:mm') + ':00';

      if (item.Domicilio) {
        const colonia = _.split(item.Domicilio.Colonia, ' ');
        const localidad = _.split(item.Domicilio.Localidad, ' ');
        const municipio = _.split(item.Domicilio.Municipio, ' ');

        item.Domicilio.Colonia = colonia[0];
        item.Domicilio.Localidad = localidad[0];
        item.Domicilio.Municipio = municipio[0];
      }

      item.Domicilio = this._clearInput(item.Domicilio);

      return this._clearInput(item);
    });

    Mercancia = Mercancia.map((item) => {
      item = this._clearInput(item);

      if (item.FechaCaducidad) {
        item.FechaCaducidad = moment(item.FechaCaducidad).format('YYYY-MM-DD');
      }

      if (!!item.DetalleMercancia) {
        item.DetalleMercancia = this._clearInput(item.DetalleMercancia);
      }

      if (!!item.DocumentacionAduanera) {
        item.DocumentacionAduanera = this._clearInput(item.DocumentacionAduanera);
      }

      if (!!item.Pedimentos) {
        item.Pedimentos = item.Pedimentos.map((item) => {
          return this._clearInput(item);
        });
      }

      if (!!item.CantidadTransporta) {
        item.CantidadTransporta = item.CantidadTransporta.map((item) => {
          return this._clearInput(item);
        });
      }

      if (!!item.GuiasIdentificacion) {
        item.GuiasIdentificacion = item.GuiasIdentificacion.map((item) => {
          return this._clearInput(item);
        });
      }

      return item;
    });

    if (!!Autotransporte) {
      Autotransporte = this._clearInput(Autotransporte);
      Autotransporte.Seguros = this._clearInput(Autotransporte.Seguros);
      Autotransporte.IdentificacionVehicular = this._clearInput(Autotransporte.IdentificacionVehicular);

      if (!!Autotransporte.Remolques?.Remolque) {
        Autotransporte.Remolques.Remolque = Autotransporte.Remolques.Remolque.map((Remolque) => {
          return this._clearInput(Remolque);
        });
      }
    }

    if (!!TiposFigura) {
      TiposFigura = TiposFigura.map((item) => {
        item = this._clearInput(item);

        if (!!item.Domicilio) {
          const colonia = _.split(item.Domicilio.Colonia, ' ');
          const localidad = _.split(item.Domicilio.Localidad, ' ');
          const municipio = _.split(item.Domicilio.Municipio, ' ');

          item.Domicilio.Colonia = colonia[0];
          item.Domicilio.Localidad = localidad[0];
          item.Domicilio.Municipio = municipio[0];

          item.Domicilio = this._clearInput(item.Domicilio);
        }

        if (!!item.PartesTransporte) {
          item.PartesTransporte = item.PartesTransporte.map((item) => {
            return this._clearInput(item);
          });
        }

        return item;
      });
    }

    cartaPorte = {
      ...cartaPorte,
      RegimenesAduaneros: {
        RegimenAduaneroCCP: [...RegimenAduaneroCCP],
      },
      Ubicaciones: {
        Ubicacion: [...Ubicacion],
      },
      Mercancias: {
        ...Mercancias,
        Mercancia: [...Mercancia],
        Autotransporte: {
          ...Autotransporte,
        },
      },
      FiguraTransporte: {
        TiposFigura: [...TiposFigura],
      },
    };

    input.Complemento = {
      ...input.Complemento,
      CartaPorte: cartaPorte,
    };

    return input;
  }

  _clearInput(input) {
    return _.pickBy(input, _.identity);
  }
}

export default ComplementoCartaPorteRequestInputTransformer;
